export enum AuthActionTypes {
  LOGOUT = 'LOGOUT',
  UPDATE_TOKEN = 'UPDATE_TOKEN',
}
